import ELK, { ElkNode } from 'elkjs/lib/elk.bundled.js';
import { Node, Edge } from '@xyflow/react';
import { ENodeType } from '../automations.types';

const elk = new ELK();

export const elkOptions = {
    'elk.algorithm': 'layered',
    'elk.direction': 'RIGHT',
    'elk.spacing.labelPortHorizontal': 1,
    'elk.layered.layering.strategy': 'NETWORK_SIMPLEX',
    'layered.nodePlacement.strategy': 'LINEAR_SEGMENTS'
};

export const getWidthByNodeType = (type: string) => {
    switch (type) {
        case ENodeType.Core:
            return 250;
        case ENodeType.Rule:
        case ENodeType.Condition:
            return 250;
        case ENodeType.And:
            return 30;
        case ENodeType.Effect:
            return 200;
        default:
            return 100;
    }
};

export const getHeightByNodeType = (type: string) => {
    switch (type) {
        case ENodeType.And:
            return 30;
        case ENodeType.Condition:
            return 54;
        case ENodeType.Effect:
            return 54;
        case ENodeType.Rule:
            return 48;
        default:
            return 34;
    }
};

export const getPositionsByType = (type: string) => {
    switch (type) {
        default:
            return { targetPosition: 'left', sourcePosition: 'right' };
    }
};

export const getLayoutedElements = (nodes: Node[], edges: Edge[], options: any = {}) => {
    const graph: ElkNode = {
        id: 'root',
        layoutOptions: options,
        children: nodes.map(node => ({
            ...node,
            ...getPositionsByType(node.type),
            // Hardcode a width and height for elk to use when layouting.
            width: getWidthByNodeType(node.type),
            height: getHeightByNodeType(node.type)
        })),
        // FIXME: possible issue?
        edges: edges as any
    };

    return elk
        .layout(graph)
        .then(layoutedGraph => ({
            nodes: layoutedGraph.children.map(node => ({
                ...node,
                // React Flow expects a position property on the node instead of `x`
                // and `y` fields.
                position: { x: node.x, y: node.y }
            })),

            edges: layoutedGraph.edges
        }))
        .catch(console.error);
};
